import React from 'react';
import { Card, Skeleton } from 'antd';
import { SkHeader } from './_primitives';

/** RulesEngineWorkflow — ReactFlow canvas: toolbar + node graph + minimap */
const RulesEngineWorkflowPageLoader = () => (
  <div className="w-full p-4 md:p-6">
    <SkHeader actions={2} />

    {/* Toolbar */}
    <Card className="shadow-sm mb-4">
      <div className="flex flex-wrap gap-2">
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton.Button key={i} active size="default" style={{ width: 110 }} />
        ))}
      </div>
    </Card>

    {/* Canvas area */}
    <Card className="shadow-sm overflow-hidden relative" styles={{ body: { padding: 0, height: '60vh', minHeight: 420 } }}>
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#f3f4f6_1px,transparent_1px),linear-gradient(to_bottom,#f3f4f6_1px,transparent_1px)] bg-[size:24px_24px]" />

      {/* Floating node skeletons */}
      <div className="absolute top-[15%] left-[10%]">
        <NodeSk color="bg-blue-100" />
      </div>
      <div className="absolute top-[15%] left-[40%]">
        <NodeSk color="bg-yellow-100" />
      </div>
      <div className="absolute top-[55%] left-[30%]">
        <NodeSk color="bg-green-100" />
      </div>
      <div className="absolute top-[55%] left-[60%]">
        <NodeSk color="bg-purple-100" />
      </div>
      <div className="absolute top-[20%] left-[70%]">
        <NodeSk color="bg-pink-100" />
      </div>

      {/* MiniMap */}
      <div className="absolute bottom-4 right-4 w-40 h-24 bg-white/80 border border-gray-200 rounded shadow-sm p-2">
        <Skeleton active paragraph={{ rows: 2 }} title={false} />
      </div>
      {/* Zoom controls */}
      <div className="absolute bottom-4 left-4 flex flex-col gap-1">
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton.Button key={i} active size="small" style={{ width: 36, height: 36 }} />
        ))}
      </div>
    </Card>
  </div>
);

const NodeSk = ({ color = 'bg-gray-100' }) => (
  <div className={`${color} border-2 border-gray-300 rounded-lg p-3 min-w-[180px] shadow-sm`}>
    <div className="flex items-center gap-2 mb-2">
      <Skeleton.Avatar active size="small" shape="circle" />
      <Skeleton.Input active size="small" style={{ width: 100 }} />
    </div>
    <Skeleton.Input active size="small" style={{ width: '100%', maxWidth: '100%' }} />
  </div>
);

export default RulesEngineWorkflowPageLoader;
